import { useState } from "react";
import { useNavigate } from "@/components/lib";
import collegeOffers from "@/images/college_offers.png";
import defaultPlayerImage from "@/images/default_american_football.png";

type PlayerProps = {
  first_name: string;
  last_name: string;
  profile_name: string;
  email?: string;
  shirt?: number;
  info?: {
    height?: { feet: number; inches: number };
    weight?: number;
    position?: string;
    offers?: string[];
    class?: string;
    stars?: number;
  };
  profile_pic?: string;
  account_id?: string;
  id?: string;
};

export default function PlayerCard({ player }: { player: PlayerProps }) {
  const navigate = useNavigate();
  const [imageError, setImageError] = useState<boolean>(false);
  const imgURL = "https://ghs-main.s3.us-east-1.amazonaws.com/";
  const profile_image = imgURL + player.profile_pic;

  return (
    <div className="relative w-full overflow-hidden shadow-lg min-h-[300px] md:hover:scale-105 transition duration-300 ease-in-out">
      {!imageError && player?.profile_pic ? (
        <img
          src={profile_image}
          alt="Grapevine High School"
          className="w-full h-[450px] md:h-[550px] lg:h-[600px] object-cover overflow-hidden"
          onError={() => setImageError(true)}
        />
      ) : (
        <img
          src={defaultPlayerImage}
          alt="Grapevine High School"
          className="w-full h-[450px] md:h-[550px] lg:h-[600px] object-cover overflow-hidden"
          onError={() => setImageError(true)}
        />
      )}

      <div
        className="absolute inset-0"
        style={{
          background:
            "linear-gradient(180deg, rgba(7, 16, 27, 0) 50%, #07101B 100%)",
        }}
      />
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 px-2 pb-4 text-white w-full text-left flex items-end">
        <div>
          <h3 className="text-3xl font-bold">
            {player.first_name} {player.last_name} #{player.shirt}
          </h3>
          <div className="flex gap-2 items-center justify-start mt-1">
            {player.info?.height?.feet ? (
              <p className="text-lg bg-[#FFFFFF1A] rounded-full px-2 py-1 w-fit">
                {player.info.height.feet}'{player.info?.height?.inches || 0}"
              </p>
            ) : null}
            {player.info?.weight ? (
              <p className="text-lg bg-[#FFFFFF1A] rounded-full px-2 py-1 w-fit">
                {player.info.weight || 0} lbs
              </p>
            ) : null}
            <p className="text-lg bg-[#FFFFFF1A] rounded-full px-2 py-1 w-fit">
              {player.info?.position || "None"}
            </p>
            <p className="text-lg bg-[#FFFFFF1A] rounded-full px-2 py-1 w-fit">
              {player.info?.class || "None"}
            </p>
          </div>
          {player.info?.offers && (
            <div className="flex gap-2 justify-start mt-2">
              <img src={collegeOffers} alt="offers" className="w-48 h-9" />
            </div>
          )}
        </div>
        <button
          onClick={() => navigate(`/${player.profile_name}`)}
          className="text-sm md:text-xl p-3 bg-[#0b0072] rounded-lg ml-auto md:hidden"
        >
          View Player
        </button>
      </div>
      <div className="absolute top-0 left-1/2 -translate-x-1/2 px-2 pb-2 text-white bg-[#CF20274D] w-full h-full text-left hidden md:flex justify-center items-center opacity-0 hover:opacity-100">
        <button
          onClick={() => navigate(`/${player.profile_name}`)}
          className="text-xl p-3 bg-[#0b0072] rounded"
        >
          View Player
        </button>
      </div>
    </div>
  );
}
